import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { GuardConfiguration } from '../models/guard-configuration';

@Injectable({
  providedIn: 'root'
})
export class GuardConfigurationService {
  private readonly API_URL = `${environment.apiUrl}/guard-configurations`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<GuardConfiguration[]> {
    return this.http.get<GuardConfiguration[]>(this.API_URL);
  }

  getActive(): Observable<GuardConfiguration[]> {
    return this.http.get<GuardConfiguration[]>(`${this.API_URL}/active`);
  }

  create(guardConfiguration: GuardConfiguration): Observable<GuardConfiguration> {
    return this.http.post<GuardConfiguration>(this.API_URL, guardConfiguration);
  }

  update(id: number, guardConfiguration: GuardConfiguration): Observable<GuardConfiguration> {
    return this.http.put<GuardConfiguration>(`${this.API_URL}/${id}`, guardConfiguration);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`);
  }
}
